export const DEFAULT_CHAT_PANE_WIDTH = 360;
export const MIN_CHAT_PANE_WIDTH = 280;
export const MAX_CHAT_PANE_WIDTH = 720;

export const clampChatPaneWidth = (
  width: number,
  viewportWidth: number,
): number => {
  const reservedMainWidth = viewportWidth < 900 ? 300 : 380;
  const responsiveMaximum = Math.max(
    MIN_CHAT_PANE_WIDTH,
    viewportWidth - reservedMainWidth,
  );
  const maximum = Math.min(MAX_CHAT_PANE_WIDTH, responsiveMaximum);
  return Math.max(MIN_CHAT_PANE_WIDTH, Math.min(maximum, width));
};
